import { create } from 'zustand';
import { currentPeriod } from '../../../domain/commissionCalculations';

/**
 * commissions feature UI state.
 * Firestore kayıtları burada YAŞAMAZ — dönem seçici, filtreler, genişletilmiş satır.
 */
const useCommissionsStore = create((set) => ({
  // ── Filtreler ──────────────────────────────────────────────
  selectedPeriod: currentPeriod(),
  statusFilter:   'all',        // 'all' | 'pending' | 'paid' | 'canceled'

  setSelectedPeriod: (period) => set({ selectedPeriod: period }),
  setStatusFilter:   (status) => set({ statusFilter: status }),

  // ── Tablo UI ───────────────────────────────────────────────
  expandedEmployeeId: null,     // Detay satırı açık olan çalışan
  selectedRecordIds:  [],       // Toplu "ödendi" işareti için

  toggleExpandEmployee: (employeeId) =>
    set((s) => ({
      expandedEmployeeId: s.expandedEmployeeId === employeeId ? null : employeeId,
    })),

  toggleSelectRecord: (id) =>
    set((s) => ({
      selectedRecordIds: s.selectedRecordIds.includes(id)
        ? s.selectedRecordIds.filter((r) => r !== id)
        : [...s.selectedRecordIds, id],
    })),

  selectAllRecords: (ids) => set({ selectedRecordIds: ids }),
  clearSelection:   ()    => set({ selectedRecordIds: [] }),
}));

export default useCommissionsStore;
